export default __webpack_public_path__ + "4d463d05fbeb6650f4f3c5b932c72877.png";